var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _vm.embedded ? "div" : "v-main",
    { tag: "component" },
    [
      _c(
        _vm.embedded ? "div" : "v-container",
        { tag: "component" },
        [
          _c(
            "v-card",
            {
              class: [
                "checkin-card",
                _vm.embedded
                  ? "checkin-card--embedded"
                  : "elevation-12 checkin-card--page",
              ],
            },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "checkin-card__header",
                  attrs: { dark: "", color: "primary" },
                },
                [
                  !_vm.embedded
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.goBack()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-arrow-left")])],
                        1
                      )
                    : _c("v-icon", { staticClass: "mr-2" }, [
                        _vm._v("mdi-alert-outline"),
                      ]),
                  _c("v-toolbar-title", { staticClass: "text-subtitle-1" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                  _c("v-spacer"),
                  !_vm.embedded
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mr-1",
                          attrs: {
                            icon: "",
                            small: "",
                            loading: _vm.loadingLogout,
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.logout()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-logout-variant")])],
                        1
                      )
                    : _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("close")
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pa-4 checkin-card__body" },
                [
                  _vm.isBlocked
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mb-4",
                          attrs: {
                            type: "warning",
                            dense: "",
                            outlined: "",
                            icon: "mdi-file-document-alert-outline",
                          },
                        },
                        [
                          _vm._v(
                            " Assine o(s) termo(s) obrigatório(s) pendentes para liberar o registro de ponto. "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "v-row",
                    { staticClass: "mb-4" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("emc-clock-server-clock", {
                            ref: "serverClock",
                            attrs: { "auto-start": true },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  _vm.teacher
                                    ? _c(
                                        "v-card-title",
                                        { staticClass: "pt-0" },
                                        [_vm._v(_vm._s(_vm.teacher.name))]
                                      )
                                    : _vm._e(),
                                  _vm.institution
                                    ? _c(
                                        "v-card-subtitle",
                                        { staticClass: "pb-2" },
                                        [_vm._v(_vm._s(_vm.institution.name))]
                                      )
                                    : _vm._e(),
                                  _vm.clockStatus && _vm.clockStatus !== "OK"
                                    ? _c(
                                        "v-alert",
                                        {
                                          staticClass: "mb-3",
                                          attrs: { type: "warning", dense: "" },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "", small: "" } },
                                            [_vm._v("mdi-clock-alert")]
                                          ),
                                          _vm._v(
                                            " Sistema de relógio temporariamente indisponível. Aguarde alguns instantes para efetuar o checkin. "
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.showLocationBlock
                                    ? _c(
                                        "div",
                                        { staticClass: "px-4 mb-3" },
                                        [
                                          _vm.checkin && _vm.checkin.company
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center mb-3",
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-3",
                                                      attrs: {
                                                        color: "primary",
                                                      },
                                                    },
                                                    [_vm._v("mdi-domain")]
                                                  ),
                                                  _c("div", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "font-weight-medium",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.checkin.company
                                                              .name
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "caption grey--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.checkin.company
                                                              .address ||
                                                              "Endereço da empresa não cadastrado"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "v-alert",
                                            {
                                              staticClass: "mb-0",
                                              attrs: {
                                                dense: "",
                                                outlined: "",
                                                type: _vm.locationAlert.type,
                                                icon: _vm.locationAlert.icon,
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(_vm.locationAlert.text)
                                                ),
                                              ]),
                                              _vm.locationAlert.detail
                                                ? _c(
                                                    "div",
                                                    { staticClass: "caption" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.locationAlert
                                                            .detail
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.locationState !== "locating"
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "mt-1 px-0",
                                                      attrs: {
                                                        small: "",
                                                        text: "",
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click: _vm.getLocation,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            left: "",
                                                            small: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-crosshairs-gps"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " Atualizar localização "
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _vm.showProof &&
                                          (_vm.position ||
                                            _vm.companyCoordinates)
                                            ? _c("sys-occurrence-fence-map", {
                                                staticClass: "mt-3",
                                                attrs: {
                                                  company:
                                                    _vm.companyCoordinates,
                                                  position: _vm.position,
                                                  radius: _vm.fence,
                                                  status: _vm.mapStatus,
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.todayClasses.length
                                    ? _c(
                                        "div",
                                        { staticClass: "px-4 mb-3" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "subtitle-2 mb-1" },
                                            [
                                              _vm._v(
                                                "Aulas de hoje (" +
                                                  _vm._s(_vm.formatedDate) +
                                                  ")"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-list",
                                            {
                                              staticClass: "py-0",
                                              attrs: { dense: "" },
                                            },
                                            _vm._l(
                                              _vm.todayClasses,
                                              function (c, index) {
                                                return _c(
                                                  "v-list-item",
                                                  {
                                                    key: index,
                                                    staticClass: "px-0",
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-icon",
                                                      { staticClass: "mr-3" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-clock-outline"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-list-item-content",
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.formatTime(
                                                                    c.start
                                                                  )
                                                                ) +
                                                                " - " +
                                                                _vm._s(
                                                                  _vm.formatTime(
                                                                    c.end
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                            c.discipline
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    " · " +
                                                                      _vm._s(
                                                                        c.discipline
                                                                      )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        c.group
                                                          ? _c(
                                                              "v-list-item-subtitle",
                                                              [
                                                                _vm._v(
                                                                  "Turma: " +
                                                                    _vm._s(
                                                                      c.group
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.todayRegisters.length
                                    ? _c(
                                        "div",
                                        { staticClass: "px-4 mb-3" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "subtitle-2 mb-1" },
                                            [
                                              _vm._v(" Marcações de hoje "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "caption grey--text",
                                                },
                                                [
                                                  _vm._v(
                                                    "(clique para baixar o comprovante)"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._l(
                                            _vm.todayRegisters,
                                            function (r, index) {
                                              return _c(
                                                "v-chip",
                                                {
                                                  key: r.id,
                                                  staticClass: "mr-1 mb-1",
                                                  attrs: {
                                                    small: "",
                                                    color:
                                                      index % 2 === 0
                                                        ? "green lighten-4"
                                                        : "orange lighten-4",
                                                    disabled:
                                                      !r.pdf_url ||
                                                      _vm.downloadingId ===
                                                        r.id,
                                                    title: r.pdf_url
                                                      ? `Baixar comprovante (NSR ${r.nsr})`
                                                      : "Comprovante indisponível para esta marcação",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.downloadReceipt(
                                                        r
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        left: "",
                                                        small: "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          index % 2 === 0
                                                            ? "mdi-login"
                                                            : "mdi-logout"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        index % 2 === 0
                                                          ? "Entrada"
                                                          : "Saída"
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.formatTime(r.time)
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        right: "",
                                                        small: "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.downloadingId ===
                                                            r.id
                                                            ? "mdi-loading mdi-spin"
                                                            : "mdi-file-download-outline"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "pa-1 ma-1 text-center" },
                    [
                      _c("v-alert", {
                        domProps: { innerHTML: _vm._s(_vm.message) },
                        model: {
                          value: _vm.snackbar,
                          callback: function ($$v) {
                            _vm.snackbar = $$v
                          },
                          expression: "snackbar",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                {
                  staticClass:
                    "checkin-card__footer flex-column flex-sm-row align-stretch align-sm-center px-4 py-3",
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-center mb-2 mb-sm-0" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: {
                                            color: "primary",
                                            "x-large": "",
                                            dark: "",
                                            outlined: "",
                                            disabled:
                                              !_vm.canMark || _vm.isBlocked,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.showMark = true
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _vm._v(" Efetuar Checkin "),
                                      _c("v-icon", { attrs: { right: "" } }, [
                                        _vm._v("mdi-clock-check-outline"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.markTooltip))])]
                      ),
                      !_vm.isClockValid
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "ml-2",
                                                attrs: { color: "warning" },
                                              },
                                              "v-icon",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [_vm._v("mdi-alert-circle")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2510408268
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v("Aguardando sincronização do relógio"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("v-spacer", { staticClass: "d-none d-sm-flex" }),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mt-2 mt-sm-0",
                      attrs: {
                        text: "",
                        small: "",
                        color: "primary",
                        disabled: _vm.isBlocked,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.goToTimeSheet()
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-calendar-edit"),
                      ]),
                      _vm._v(" Corrigir marcações no Cartão de Ponto "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("emc-alert-modal", {
            attrs: {
              text: "Confirma a marcação do checkin?",
              disabled: _vm.loadingMark,
              show: _vm.showMark,
            },
            on: {
              "update:show": function ($event) {
                _vm.showMark = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "actions",
                fn: function () {
                  return [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          color: "primary",
                          loading: _vm.loadingMark,
                          disabled: _vm.loadingMark,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.mark()
                          },
                        },
                      },
                      [
                        _vm._v(" Realizar Checkin "),
                        _c("v-icon", { attrs: { right: "", dark: "" } }, [
                          _vm._v("mdi-clock-check-outline"),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("emc-alert-snackbar", {
            attrs: {
              show: !!_vm.message.length,
              message: _vm.message,
              color: _vm.error ? "error" : "success",
            },
          }),
          _c("sys-occurrence-time-punch-receipt", {
            attrs: { receipt: _vm.receipt },
            on: { close: _vm.closeReceipt },
            model: {
              value: _vm.showReceipt,
              callback: function ($$v) {
                _vm.showReceipt = $$v
              },
              expression: "showReceipt",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }